import React, { useEffect, useState } from "react";
import { MdOutlineContentCopy,MdEmail } from "react-icons/md";
import { ImWhatsapp } from "react-icons/im";
import { FaTelegram } from "react-icons/fa";



import './Refer.scss';
import { baseUrl } from "../../../../utils/config/urls";
import axios from "axios";
import { getAccessToken } from "../../../../utils/services/auth";
import { copyToClipboard } from "../../../../utils/services/other";

function Refer() {

  const [referralId, setReferralId] = useState<string>('');

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {

      (async ()=>{
        const response = await axios.get(
          `${baseUrl}/api/user/get_referral_code`,
          {
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
            },
          }
        );
     
        if(response?.data?.referralCode) setReferralId(response?.data?.referralCode)
      })()
   
    }
    return () => {
      componentMounted = false;
    };
  }, []);
  return (
    <div className="Refer">
    <div className="Refer__title">
      <p>Refer And Earn 10% Balance <br />
      <small style={{fontWeight:'300'}}>of all transaction data made by referred user</small>
      </p>
    </div>

    <div className="Refer__InfoContainer">
      <div className="AddressContainer">
        <div className="label">Your unique Refer ID</div>
        <div className="addressBox">
          <p className="address">
            {referralId}{" "}
            <span
              className="icon ptr"
              onClick={() => {
               copyToClipboard(referralId)
              }}
            >
              <MdOutlineContentCopy />
            </span>
          </p>
        </div>
      </div>
      <div className="AddressContainer">
        <div className="label">Refer Link</div>
        <div className="addressBox">
          <p className="address">
            {`https://files.lighthouse.storage/?referBy=${referralId}`}{" "}
            <span
              className="icon ptr"
              onClick={() => {
                copyToClipboard(`https://files.lighthouse.storage/?referBy=${referralId}`)
              }}
            >
              <MdOutlineContentCopy />
            </span>
          </p>
        </div>
      </div>
      <div className="AddressContainer">
        <div className="label">Share Link Via</div>
        <div className="addressBox">
          <p className="address" style={{fontSize:'1.6rem'}}>
          <ImWhatsapp onClick={() => window.open(`https://wa.me/?text=Join me on Lighthouse Storage! Use my referral link: https://files.lighthouse.storage/?referBy=${referralId}`)} className="ptr" /> &nbsp;
          <FaTelegram onClick={() => window.open(`https://t.me/share/url?url=https://files.lighthouse.storage/?referBy=${referralId}&text=Join me on Lighthouse Storage! Use my referral link:`)} className="ptr" /> &nbsp;
          <MdEmail onClick={() => window.open(`mailto:?subject=Join me on Lighthouse Storage!&body=Use my referral link: https://files.lighthouse.storage/?referBy=${referralId}`)} className="ptr" /> &nbsp;
          </p>
        </div>
      </div>
   

    </div>
   
  </div>
  );
}

export default Refer;
